import { CButton } from "@app/components/Common";
import { COLORS } from "@app/constants";
import React, {useContext} from "react";
import { useTranslation } from "react-i18next";
import { View } from "@/styles/reactnative";
import { useTradeSetting } from "../../../../../../hooks/trade/tradeSetting";
import {useMobileDimensions} from "@app/hooks";
import {ThemeContext} from "@/theme/ThemeProvider.tsx";
import { useTradePosition } from "../../../../../../hooks/trade/tradePosition";
import { message } from "antd";

interface IProps {
  cross_iso: string;
  leverage: number;
  ep_id: number;
  closeModal?: () => void;
  handleConfirm?: () => void;
}

const CrossModalFooter = ({
  cross_iso,
  leverage,
  ep_id,
  closeModal,handleConfirm
}: IProps) => {
  const { t } = useTranslation();
  const { mutate: mutateTradeSetting } = useTradeSetting(ep_id);
  const { isMobile } = useMobileDimensions();
  const { borderColor, textw } = useContext(ThemeContext).theme.COLORS;
  const { data: positions } = useTradePosition();

  const hasPosition = positions?.some((pos: any) => +pos.exchange_pairs_id === +ep_id);

  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "center",
        gap: 12,
        width: "100%",
        marginTop: isMobile ? 12 : 18,
        position: "relative",
      }}
    >
      <CButton
        title={t("cancel")}
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'transparent',
          color: '#ffffff',
          borderRadius: 6,
          border: '1px solid #353535',
          cursor: "pointer",
          fontSize: 14,
          fontWeight: 700,
          height: 42,
          letterSpacing: '-0.28px',
          fontFamily: 'NanumSquareRound'
        }}
        onClick={() => {
          closeModal && closeModal();
        }}
      />
      <CButton
        title={t("confirm")}
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#07D993',
          color: '#0d1117',
          borderRadius: 6,
          cursor: "pointer",
          fontSize: 14,
          fontWeight: 700,
          height: 42,
          letterSpacing: '-0.28px',
          fontFamily: 'NanumSquareRound'
        }}
        onClick={() => {
          if (hasPosition) {
            message.warning(t("cannotChangeWhilePosition"));
            return;
          }
          mutateTradeSetting({ leverage, cross_iso }, ep_id);
          closeModal && closeModal();
        }}
      />
    </View>
  );
};

export default CrossModalFooter;
